import { Injectable } from '@angular/core';
import { Http, Response, URLSearchParams, RequestOptions } from '@angular/http';

import { Observable } from 'rxjs/Rx';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';

import { ErrorService } from '../errors/error.service';
import { Campaign } from './campaign.model';

@Injectable()
export class CampaignService {
  public currentPage = 1;
  public requestUrl: string;

  constructor (
    private http: Http,
    private err:  ErrorService
  ) {
    this.err.clearError();
    this.requestUrl = '/api/campaigns';
  };

  getCampaigns(page: number, project_id: string): Observable<Campaign[]> {
    return this.http.get(
      `/api/projects/${project_id}/campaigns?page=${page}`
    ).map(this.extractData).catch(err =>  {
      return this.err.setError(err);
    });
  }

  createCampaign(project_id: string, campaign: Campaign): Observable<Campaign> {
    return this.http.post(
      `/api/projects/${project_id}/campaigns`, {campaign: campaign}
    ).map(this.extractData).catch(err =>  {
      return this.err.setError(err);
    });
  }

  updateCampaign(campaign_id, campaign: Campaign): Observable<Campaign> {
    return this.http.put(
      `${this.requestUrl}/${campaign_id}`, {campaign: campaign}
    ).map(this.extractData).catch(err =>  {
      return this.err.setError(err);
    });
  }

  getCampaign(id: string): Observable<Campaign> {
    return this.http.get(
      `${this.requestUrl}/${id}`
    ).map(this.extractData).catch(err =>  {
      return this.err.setError(err);
    });
  }

  protected extractData(res: Response) {
    let body = res.json();
    return body || { };
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/campaigns/campaign.service.ts